import React from 'react'
import ControlsMenu from './ControlsMenu'


export default function AdminPanel() {
    return (
        <div>
            <h1>Admin Panel</h1>
            <ControlsMenu />
        </div>
    )
}